import { KeycloakStratAuthenticator } from '@sector-labs/fe-auth-redux';

const keycloakConfig = {
  url: `${process.env.REACT_APP_KEYCLOAK_URL}/auth`,
  realm: 'olx-pk',
  clientId: 'frontend',
};

const getKeycloak = async () =>
  (await import('@utils/app-utils.js'))?.isDevMode()
    ? (async () => {
        const Keycloak = (await import('keycloak-js')).default;
        return new Keycloak(keycloakConfig);
      })()
    : new KeycloakStratAuthenticator(
        `${process.env.REACT_APP_KEYCLOAK_URL}/`,
        'olx-pk',
        'frontend',
        process.env.REACT_APP_OLX_PK_KEYCLOACK_AUTH_URL
      );

const keycloak = getKeycloak();

export default keycloak;
